import { useCallback } from 'react'
import { generatePath } from 'react-router-dom'
import { useRoutes } from 'utils/hooks'
import { ELD_ROUTES } from '../components/eld-integration'

export const useFMSRoutes = () => {
  const history = useRoutes({
    ...ELD_ROUTES,
  })

  /**
   * Send user to page where they connect via integration
   * @example history.pushToConnectCarrier(carrierId, integrationType)
   */
  const pushToConnectCarrier = useCallback(
    (carrierId: string | number, newWindow = false) => {
      const pathWithParams = generatePath(ELD_ROUTES.connect.location, {
        carrierId,
      })
      if (newWindow) {
        const win = window.open(`${__ROOT__}/fms${pathWithParams}`, '_blank')
        if (win) win.focus()
      } else {
        history.push(pathWithParams)
      }
    },
    [history]
  )

  /**
   * Routes user to import trucks
   * @example history.pushToImportTrucks(carrierId, integrationType)
   */
  const pushToImportTrucks = useCallback(
    (carrierId: string | number) => {
      const pathWithParams = generatePath(ELD_ROUTES.importTrucks.location, {
        carrierId,
      })
      history.push(pathWithParams)
    },
    [history]
  )

  const pushToFleetViewTruck = useCallback(
    (id: number) => {
      const pathWithParams = generatePath('/fleet/:id', {
        id,
      })
      history.push(pathWithParams)
    },
    [history]
  )

  return {
    ...history,
    pushToConnectCarrier,
    pushToImportTrucks,
    pushToFleetViewTruck,
  }
}
